<template>
  <el-container>
    <!-- 筛选区 -->
    <el-header>
      <el-form :inline="true">
        <el-form-item label="操作日期">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="操作人">
          <el-input
            v-model="searchForm.userName"
            placeholder="请输入操作人"
            clearable
            style="width: 160px"
            @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="日志内容">
          <el-input
            v-model="searchForm.content"
            placeholder="请输入日志内容关键词"
            clearable
            style="width: 180px"
            @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-header>

    <!-- 列表区 -->
    <el-main>
      <grid-table
        ref="gridTable"
        :showIndexColumn="false"
        :showCheckboxColumn="false"
        :showLastEmptyColumn="false"
        :tableConfig="tableConfig">
        <template slot="Content" slot-scope="{ params }">
          <div class="log-content">{{ params.row.Content }}</div>
        </template>
      </grid-table>
    </el-main>
  </el-container>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'logOperation',
  data() {
    return {
      searchForm: this.buildDefaultForm(),
      tableConfig: {
        url: '/api/logManage/getLogOperationList',
        rowKey: 'Auid',
        columns: [
          { label: '操作人', prop: 'UserName', type: 'text', width: '150px' },
          { label: '日志内容', prop: 'Content', type: 'custom-operation', minWidth: '260px', align: 'left' },
          {
            label: '操作时间',
            prop: 'AppendTime',
            type: 'text-datetime',
            dateFormat: 'yyyy-MM-dd HH:mm:ss',
            width: '180px',
          },
          { label: 'IP地址', prop: 'IPAddress', type: 'text', width: '150px' },
        ],
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchData();
    });
  },
  methods: {
    // 近 7 天的默认查询日期范围
    buildDefaultForm() {
      return {
        dateRange: [dayjs().subtract(7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
        userName: '',
        content: '',
      };
    },
    // 组装查询参数
    buildQueryParam() {
      const { dateRange, userName, content } = this.searchForm;
      const searchParm = {
        startTime: dateRange?.[0] || '',
        endTime: dateRange?.[1] || '',
        userName,
        content,
      };
      return searchParm;
    },
    // 查询日志列表
    fetchData() {
      this.$refs.gridTable.fetchData(false, null, this.buildQueryParam());
    },
    handleSearch() {
      const { dateRange } = this.searchForm;
      if (!dateRange || dateRange.length < 2) {
        this.$message({ type: 'warning', message: '请选择操作时间' });
        return;
      }
      if (dayjs(dateRange[1]).diff(dayjs(dateRange[0]), 'day') > 90) {
        this.$message({ type: 'warning', message: '查询时间跨度不能超过3个月' });
        return;
      }
      this.fetchData();
    },
    handleReset() {
      this.searchForm = this.buildDefaultForm();
      this.fetchData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

::v-deep {
  .el-header {
    height: 54px !important;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px 0 !important;

    .el-form {
      .el-form-item {
        margin-bottom: 5px !important;
      }
    }
  }

  .el-main {
    border-top: 0px !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .grid-table {
      flex: 1;
      height: 100%;
    }
  }
}

/* 日志内容直接显示全部内容，自动换行 */
::v-deep .el-main .log-content {
  white-space: normal;
  word-break: break-all;
}
</style>
